/** returns Tpas List
@return { Array }
*/
export const getTpaList = state => state.tpaList

/** returns List of Operation Detail
@return { Array }
*/
export const getOperationDetail = state => state.operationDetail

/** returns Has More Tpa List
 @return { Boolean }
 */
 export const getTpaListHasMore = state => state.tpaListHasMore
